import { StyledBox } from '../styledBox/StyledBox'

export const StyledBoxThreeDX = StyledBox.extend`
  perspective: ${({ buttonWidth }) => buttonWidth * 2}px;
`

StyledBoxThreeDX.displayName = 'StyledBoxThreeDX'



// WEBPACK FOOTER //
// ./src/node_modules/components/HamburgerThreeDX/StyledBoxThreeDX.js